import React from 'react';
import EmbeddedBackButton from 'features/EmbeddedBackButton';

const ApplicationLayout: React.FC = ({ children }) => {
  return (
    <div>
      <EmbeddedBackButton />
      {children}
    </div>
  );
};

export default ApplicationLayout;
